// tool-storage.js: kleine helper voor de losse tools.
//
// Bewust GEEN persistentie: elke tool start altijd vers met de prefilled
// waardes uit `initialState`. Alleen de in-memory React state wordt bijgehouden
// tijdens de sessie zelf.
import React from "react";

export function useToolState(key, initialState) {
  const [state, setState] = React.useState(initialState);
  const resetState = React.useCallback(() => setState(initialState), [initialState]);
  return [state, setState, resetState];
}

export function useToolStep(key, _maxStep) {
  const [step, setStep] = React.useState(0);
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [step]);
  return [step, setStep];
}

// Eenmalige opruimactie: verwijder oude per-tool sleutels uit eerdere versies.
try {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const k = localStorage.key(i);
    if (k && k.startsWith("fw-tool-")) localStorage.removeItem(k);
  }
} catch { /* ignore */ }
